var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUserNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 144,
    viewBox: "0 0 188 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.85 54.9001C152.85 69.1001 147.05 81.9001 137.75 91.1001C128.65 100.2 116.05 105.7 102.15 105.7C88.3502 105.7 75.7502 100.1 66.5502 91.1001C57.2502 81.9001 51.4502 69.1001 51.4502 54.9001C51.4502 26.8001 74.1502 4.1001 102.15 4.1001C130.15 4.1001 152.85 26.9001 152.85 54.9001Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.45 21.5999C150.714 21.5999 152.55 19.7643 152.55 17.4999C152.55 15.2355 150.714 13.3999 148.45 13.3999C146.186 13.3999 144.35 15.2355 144.35 17.4999C144.35 19.7643 146.186 21.5999 148.45 21.5999Z",
    fill: "#D7DEEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.45 5.6C155.996 5.6 157.25 4.3464 157.25 2.8C157.25 1.2536 155.996 0 154.45 0C152.904 0 151.65 1.2536 151.65 2.8C151.65 4.3464 152.904 5.6 154.45 5.6Z",
    fill: "#D7DEEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.05 21.4999C54.5964 21.4999 55.85 20.2463 55.85 18.6999C55.85 17.1535 54.5964 15.8999 53.05 15.8999C51.5036 15.8999 50.25 17.1535 50.25 18.6999C50.25 20.2463 51.5036 21.4999 53.05 21.4999Z",
    fill: "#D7DEEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.95 75.5001C38.8219 75.5001 41.15 73.172 41.15 70.3001C41.15 67.4282 38.8219 65.1001 35.95 65.1001C33.0781 65.1001 30.75 67.4282 30.75 70.3001C30.75 73.172 33.0781 75.5001 35.95 75.5001Z",
    fill: "#D7DEEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.915 105.413C117.994 105.413 131.028 102.9 131.028 99.8002C131.028 96.7001 117.994 94.187 101.915 94.187C85.8358 94.187 72.8013 96.7001 72.8013 99.8002C72.8013 102.9 85.8358 105.413 101.915 105.413Z",
    fill: "#A0A9BA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_5195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.146 31.2937C145.778 29.3801 143.726 29.5502 142.999 31.889C141.374 37.077 136.287 38.9906 133.166 39.4583C131.371 26.1482 119.913 15.8999 106.062 15.8999C92.2534 15.8999 80.8388 26.1057 79.0005 39.3307C75.837 38.7354 71.2198 36.7793 69.6808 31.8465C68.954 29.5077 66.902 29.3801 65.5339 31.2511C62.7551 35.0783 63.9094 39.9686 65.6194 43.9659C68.1418 50.0469 73.0154 54.3843 78.744 57.3185C78.6158 64.5051 78.1028 70.3734 76.0935 77.9427C75.4095 80.5367 74.8109 82.6629 74.2552 84.0662C73.8704 85.0443 73.6139 86.0223 74.2124 87.0004C75.2385 88.6588 77.2478 89.1691 79.086 89.4668C80.7961 89.7645 82.2496 89.8921 83.4467 89.9346C86.3537 90.0196 87.6363 89.5944 87.6363 89.5944C87.6363 89.5944 87.85 89.9346 88.4058 90.4023C89.9876 91.8056 94.3909 94.5272 104.309 94.1445C142.999 132.834 121.41 92.486 123.59 90.615C123.761 90.4449 123.932 90.3173 124.06 90.1472C125.428 90.1472 126.668 90.1897 127.78 90.1897C131.67 90.2322 134.449 90.3173 136.672 89.5093C138.425 88.8715 139.536 86.8303 138.425 84.6616C135.09 78.1128 133.38 70.8837 133.38 63.527V57.5736C139.322 54.6395 144.453 50.2595 147.06 43.9659C148.77 39.9686 149.925 35.0783 147.146 31.2937Z",
    fill: "url(#paint0_linear_5_5195)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.675 90.1045C122.521 90.1045 121.281 90.062 119.956 90.062C119.827 90.2321 119.656 90.4022 119.485 90.5297C118.246 85.0441 117.177 79.4309 116.92 72.542C118.673 78.4529 120.896 85.4268 123.675 90.1045Z",
    fill: "#DFE0E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2585 90.3599C83.7027 89.8921 83.4889 89.5519 83.4889 89.5519C83.4889 89.5519 82.2064 90.0197 79.2993 89.8921C81.7361 85.427 83.9164 77.0498 83.6599 71.8618C84.0447 81.0045 84.1729 86.7453 84.2585 90.3599Z",
    fill: "#DFE0E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 47C94.9853 47 97 44.9853 97 42.5C97 40.0147 94.9853 38 92.5 38C90.0147 38 88 40.0147 88 42.5C88 44.9853 90.0147 47 92.5 47Z",
    fill: "#171923"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.166 48.771C113.259 48.771 115.766 46.2769 115.766 43.2003C115.766 40.1237 113.259 37.6296 110.166 37.6296C107.073 37.6296 104.565 40.1237 104.565 43.2003C104.565 46.2769 107.073 48.771 110.166 48.771Z",
    fill: "#171923"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_5195",
    x: 41.8623,
    y: 4.8999,
    width: 128.955,
    height: 138.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_5195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_5195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_5195",
    x1: 102.166,
    y1: 14.0892,
    x2: 102.166,
    y2: 95.0249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserNew);
export default __webpack_public_path__ + "static/media/noUserNew.4053196a8db64f0745de7cfa23d1523e.svg";
export { ForwardRef as ReactComponent };